export default __webpack_public_path__ + "static/media/jackpot7.2830c08d.png";